import Attendance from "@/views/attendance/views/Attendance.vue";
import myAttendanceRoute from "@/views/attendance/views/my-attendance/router/my-attendance.route.js";

const routes = [
    {
        path: "/attendance",
        name: "attendance",
        component: Attendance,
        redirect: { name: "my-attendance" },
        meta: {
            section: 0,
            breadcrumb: [
                {
                    text: "Profile",
                    active: true,
                },
            ],
        },
        children: [...myAttendanceRoute]
    },
];

export default routes;